import { render } from "./login-form-head.vue?vue&type=template&id=1ae95c82&scoped=true"
import script from "./login-form-head.vue?vue&type=script&lang=js"
export * from "./login-form-head.vue?vue&type=script&lang=js"

import "./login-form-head.vue?vue&type=style&index=0&id=1ae95c82&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae95c82"]])

export default __exports__